import angular = require('angular');
import _ = require('underscore');
import { PopupService } from '../../../../app.common/modules/common/services/popup.service';
import { CategoryListItem } from '../../../../app.retailer/modules/core';
import { IClassificationCategoriesValidateComponent } from '../classification-categories-base.component';

export interface IChoiceClassificationCategoriesOptions {
    singleSelect: boolean;
    selectedCategories: CategoryListItem[];
    businessType: number;
    isOnlyStoreCategories?: boolean;
    subcategoryId?: number;
    // tslint:disable-next-line:ban-types
    getCategoriesTree?: Function;
}

class SelectClassificationCategoriesController {
    public static $inject = ['popupService', '$translate'];

    public modalInstance: ng.ui.bootstrap.IModalServiceInstance = this as any;
    public resolve: { options: IChoiceClassificationCategoriesOptions, languageId: number };
    public classificationCategoriesErrors: IClassificationCategoriesValidateComponent;
    private startSelectedCategories: CategoryListItem[];

    constructor(private popupService: PopupService, private $translate: angular.translate.ITranslateService) {
    }

    public $onChanges(changes: any) {
        if (changes.resolve) {
            this.startSelectedCategories = this.resolve.options.selectedCategories;
        }
    }

    public changeClassificationCategory() {
        return;
    }

    public isPristine() {
        if (_.isEmpty(this.resolve.options.selectedCategories)) {
            return true;
        } else if (_.isEmpty(this.startSelectedCategories) && !_.isEmpty(this.resolve.options.selectedCategories)) {
            return false;
        } else if (!_.isEmpty(this.resolve.options.selectedCategories) && !_.isEmpty(this.startSelectedCategories)) {
            if (_.size(this.resolve.options.selectedCategories) === _.size(this.startSelectedCategories)) {
                return !_.any(this.resolve.options.selectedCategories, (item) => {
                    return !_.any(this.startSelectedCategories, (category) => {
                        return category.CategoryID === item.CategoryID;
                    });
                });
            } else {
                return false;
            }

        }
        return true;
    }

    public select = async () => {
        if (this.isRemoveBrands()) {
            try {
                await this.popupService.confirm({
                    title: this.$translate.instant('remove_category_and_brands'),
                    content: `<p>${this.$translate.instant('remove_category_and_brands_confirm')}</p>`
                });
            } catch (error) {
                return;
            }
        }
        this.modalInstance.close({
            $value: this.resolve.options.selectedCategories
        });
    }

    public discard = () => {
        this.modalInstance.dismiss({ $value: 'cancel' });
    }

    private isRemoveBrands() {
        const ids = _.pluck(this.resolve.options.selectedCategories, 'CategoryID');
        const absence = _.filter(this.startSelectedCategories, (category) => {
            return !_.contains(ids, category.CategoryID);
        });
        return _.any(absence, (item) => {
            return false; // item.Brands && _.any(item.Brands);
        });
    }
}

angular.module('app.retailes.common').component('selectClassificationCategories', {
    template: require('./select-classification-categories.html'),
    controller: SelectClassificationCategoriesController,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/categories/select-classification-categories/select-classification-categories.component.ts